import { useIntl } from 'react-intl'
import styled from 'styled-components'
import React, { useCallback } from 'react'
import { SmallText } from 'app/common/typography'
import { colors } from '../../app-v2/design-systems'
import { Chevron } from 'app/assets/icons'
import { SPACING } from 'app-v2/design-tokens'
import { useHistory } from 'react-router-dom'

export const MeatOrigin = () => {
    const intl = useIntl()
    const history = useHistory()

    const handleClick = useCallback(() => {
        history.push(intl.formatMessage({ id: 'routes.meat.origin.full' }))
    }, [])
    return (
        <StyledContainer onClick={handleClick}>
            <SmallText>
                {intl.formatMessage({ id: 'product.nutritional.meat.origin' })}
            </SmallText>

            <Chevron color={colors.bbqBrown} />
        </StyledContainer>
    )
}

const StyledContainer = styled.div`
    padding: ${SPACING.XS} 0;
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
`
